export class FileUtils {

    static getBlobFromBinaryString(str: string) {
        try {
            const array = new Uint8Array(str.length);

            for (let i = 0; i < str.length; i++) {
                array[i] = str.charCodeAt(i);
            }

            return new Blob([array], { type: 'application/octect-stream' });
        } catch (error) {
            console.error(error);
        }
    }

    static async convertToBlob(base64: string, contentType: string = 'image/jpg'): Promise<Blob> {
        let data = await atob(base64.replace(/^[\w\d;:\/]+base64\,/g, ''))
        const byteNumbers = new Array(data.length);
        for (let i = 0; i < data.length; i++) {
            byteNumbers[i] = data.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: contentType });

        return blob;
    }
}